module.exports = __webpack_public_path__ + "static/media/shape01b-mob.279bbcc8.svg";